export default "__VITE_ASSET__Ueimj9j5__"